/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { communicationV1EmailsSyncCreate } from '../../__generated__/oazapfts-client';
import { GetAllCommunications } from '../queries/get-all-communications';

export namespace CommunicationSync {
  export type Input = {};
  export type Output = void;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const auth = useAuth();
    const me = useMe();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn() {
        const accessToken = await auth.getAccessToken();
        const result = await communicationV1EmailsSyncCreate({
          baseUrl: `${appConfig.bffUrl}/plex`,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'x-user-name': me.displayName,
            'x-user-email': me.email,
          },
        });

        if (result.status !== 200) {
          throw new Error('Fail to fetch communications');
        }
      },
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: GetAllCommunications.key({}),
        });
      },
    });
  }
}
